import React, { useEffect, useState } from "react";
import "../../css/CRUDModal.css";
import { apiList } from "../../helpers/apiList";
import CustomAlert from "../../helpers/CustomAlert";
import { axiosPostApi } from "../../helpers/interceptorServices";

const ChangePartnerRateModal = ({ show, handleClose, callApi, columnData }) => {
  const loggedInUserName = sessionStorage.getItem("username");

  const [formData, setFormData] = useState({
    partnerSmsRate: "",
    partnerRcsRate: "",
    partnerRcsUtlRate: "",
  });

  const [errors, setErrors] = useState({
    partnerSmsRate: "",
    partnerRcsRate: "",
    partnerRcsUtlRate: "",
  });

  useEffect(() => {
    if (show) {
      setFormData({
        partnerSmsRate: columnData?.partnerSmsRate ?? "",
        partnerRcsRate: columnData?.partnerRcsRate ?? "",
        partnerRcsUtlRate: columnData?.partnerRcsUtlRate ?? "",
      });
      setErrors({
        partnerSmsRate: "",
        partnerRcsRate: "",
        partnerRcsUtlRate: "",
      });
    }
  }, [show, columnData]);

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({ ...prev, [id]: value }));
  };

  const validateField = (id, value) => {
    const trimmedValue = value?.toString().trim();
    if (!trimmedValue) {
      const labels = {
        partnerSmsRate: "Partner SMS Rate",
        partnerRcsRate: "Partner RCS Promotional Rate",
        partnerRcsUtlRate: "Partner RCS Utility Rate",
      };
      return `${labels[id]} is required`;
    }
    if (!/^\d+(\.\d+)?$/.test(trimmedValue) || Number(trimmedValue) <= 0) {
      return "Enter a valid rate greater than 0";
    }
    return "";
  };

  const validate = () => {
    const newErrors = {};
    const smsError = validateField("partnerSmsRate", formData.partnerSmsRate);
    const rcsError = validateField("partnerRcsRate", formData.partnerRcsRate);
    if (smsError) newErrors.partnerSmsRate = smsError;
    const rcsUtlError = validateField(
      "partnerRcsUtlRate",
      formData.partnerRcsUtlRate,
    );
    if (rcsError) newErrors.partnerRcsRate = rcsError;
    if (rcsUtlError) newErrors.partnerRcsUtlRate = rcsUtlError;
    return newErrors;
  };

  const handleBlur = (e) => {
    const { id, value } = e.target;
    setErrors((prev) => ({ ...prev, [id]: validateField(id, value) }));
  };

  const handleBack = () => {
    handleClose();
    setErrors({});
  };

  const handleSubmit = () => {
    const validationErrors = validate();
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      const payload = {
        username: loggedInUserName,
        customerCode: columnData?.customerCode || "",
        partnerSmsRate: Number(formData.partnerSmsRate),
        partnerRcsRate: Number(formData.partnerRcsRate),
        partnerRcsUtlRate: Number(formData.partnerRcsUtlRate),
      };

      axiosPostApi(apiList.SET_PARTNER_RATES, payload)
        .then((response) => {
          if (response?.status === 200 && response?.data?.status === true) {
            CustomAlert({
              title: "Success",
              text: response?.data?.message || "Partner rates updated successfully",
              icon: "success",
              confirmButtonText: "OK",
            });
            callApi();
            handleClose();
          } else {
            CustomAlert({
              title: "Failed to Update Partner Rates",
              text:
                response?.data?.message ||
                "There was an issue processing the request. Please try again.",
              icon: "error",
              confirmButtonText: "Retry",
            });
          }
        })
        .catch((error) => {
          console.error("Error updating partner rates:", error);
          CustomAlert({
            title: "Error",
            text: "An error occurred while updating partner rates. Please try again later.",
            icon: "error",
            confirmButtonText: "Retry",
          });
        });
    }
  };

  return (
    <>
      {show && (
        <div
          style={{
            position: "fixed",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            backgroundColor: "rgba(0,0,0,0.4)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1031,
          }}
        >
          <div className="modal-dialog" role="document">
            <div
              className="modal-content"
              style={{
                width: "500px",
                borderRadius: "24px",
                padding: "24px",
                backgroundColor: "#FFF",
                border: "1px solid rgba(0, 0, 0, 0.175)",
              }}
            >
              <div
                className="modal-header"
                style={{
                  padding: "1rem 1rem",
                  borderBottom: "1px solid #dee2e6",
                }}
              >
                <h5 className="modal-title main-title">Change Partner Rate</h5>
              </div>
              <form>
                <div className="scoped-modal modal-body">
                  <div className="row mb-3">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="partnerSmsRate">
                          Partner SMS Rate
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="partnerSmsRate"
                          placeholder="Partner SMS Rate"
                          value={formData.partnerSmsRate}
                          onChange={handleInputChange}
                          onBlur={handleBlur}
                        />
                        {errors.partnerSmsRate ? (
                          <span className="error">{errors.partnerSmsRate}</span>
                        ) : null}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="partnerRcsRate">
                          Partner RCS Promotional Rate
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="partnerRcsRate"
                          placeholder="Partner RCS Promotional Rate"
                          value={formData.partnerRcsRate}
                          onChange={handleInputChange}
                          onBlur={handleBlur}
                        />
                        {errors.partnerRcsRate ? (
                          <span className="error">{errors.partnerRcsRate}</span>
                        ) : null}
                      </div>
                    </div>
                  </div>
                  <div className="row mb-3">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="partnerRcsUtlRate">
                          Partner RCS Utility Rate
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="partnerRcsUtlRate"
                          placeholder="Partner RCS Utility Rate"
                          value={formData.partnerRcsUtlRate}
                          onChange={handleInputChange}
                          onBlur={handleBlur}
                        />
                        {errors.partnerRcsUtlRate ? (
                          <span className="error">
                            {errors.partnerRcsUtlRate}
                          </span>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className="scoped-modal mt-2"
                  style={{
                    display: "flex",
                    justifyContent: "end",
                    padding: "12px",
                    paddingTop: "0px",
                    gap: "16px",
                  }}
                >
                  <button
                    type="button"
                    className="btn btn-back"
                    onClick={handleBack}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-submit"
                    onClick={handleSubmit}
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ChangePartnerRateModal;
